import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { DealsPartnerships } from '@/components/brand/DealsPartnerships';

const DealsPartnershipsPage = () => {
  return (
    <Layout>
      <PageHeader 
        title="Deal Marketplace." 
        subtitle="Manage and track your partnerships"
      />
      <div className="container mx-auto max-w-[1200px] overflow-x-hidden px-2 sm:px-4 md:px-6 py-4 sm:py-6">
        <DealsPartnerships />
      </div>
    </Layout>
  );
};

export default DealsPartnershipsPage;